import axios from './common/axios';

export default {
  /*
  Add items to the shopping cart
  @param {Object} params
  @param {String} params.product_id - Product id
  @param {String} params.sku_id - Product sku id
  @param {String} params.wishlist_id - Wish list id
  @param {String} params.variation_id - Variation id
  @param {String} params.mangaplus_id - MANGA Plus の詳細画面の URL の id
  @param {String} params.mangaplus_page - MANGA Plus の詳細画面の URL の page
  @param {String} params.mangaplus_h - MANGA Plus の詳細画面の URL の h
  @param {Function} callback - Callback method
  */
  addToCart(params, callback) {
    axios
      .get('/cart/add', {
        params: {
          sku_id: params.sku_id,
          product_id: params.product_id,
          wishlist_id: params.wishlist_id,
          variation_id: params.variation_id,
          mangaplus_id: params.mangaplus_id,
          mangaplus_page: params.mangaplus_page,
          mangaplus_h: params.mangaplus_h,
          format: 'json'
        }
      })
      .then(function (res) {
        if (res.data.status === 'ng') {
          callback(new Error(res.data.errors.general));
          return;
        }
        if (!res.data.additionSuccess) {
          const error = new Error('No more can be added to your cart.');
          error.type = 'overMaxPurchaseQty';
          callback(error);
          return;
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  /*
  Change flag to join TOM Premium
  @param {Object} params
  @param {Boolean} params.join - Will join to TOM Premium or not
  */
  joinPremium(params, callback) {
    const method = params.join ? 'post' : 'delete';

    axios
      .request({
        url: '/cart/enable_premium_plan',
        method,
        data: {
          wishlist_id: params.wishlist_id,
          _csrf: params._csrf
        }
      })
      .then(function (res) {
        if (res.data.status === 'ng') {
          return callback(new Error(res.data.message));
        }

        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  /*
  Fetch selectable shipping methods for shipmentId and/or shippingId.
  @param {Object} params
  @param {String} params.shipmentId - cart.shipments.id, not Shipments._id
  @param {String} params.shippingId - Shippings._id
  */
  fetchSelectableShippingMethods(params, callback) {
    if (!params) {
      params = {};
    }
    axios
      .post('/cart/selectable_shipping_methods', {
        shipment_id: params.shipmentId,
        shipping_id: params.shippingId,
        shipping_address: params.shippingAddress
      })
      .then(function (res) {
        if (res.data.status === 'ng') {
          return callback(new Error(res.data.errors.general));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  /*
  Clear in-cart items.
  @param {Object} params
  */
  clearCart(params, callback) {
    if (!params) {
      params = {};
    }
    axios
      .post('/cart/clear')
      .then(function (res) {
        if (res.data.status === 'ng') {
          return callback(new Error(res.data.errors.general));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  /*
  Checkout in-cart items.
  @param {Object} params
  */
  checkout(params, callback) {
    if (!params) {
      params = {};
    }
    axios
      .post('/cart/checkout', {
        wishlist_id: params.wishlistId
      })
      .then(function (res) {
        if (res.data.status === 'ng') {
          return callback(new Error(res.data.errors.general));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  /*
  Checkout in-cart items.
  @param {Object} params
  */
  checkoutWithPaypal(params, callback) {
    if (!params) {
      params = {};
    }
    axios
      .get('/cart/checkout/paypal', {
        params: {
          wishlist_id: params.wishlistId
        }
      })
      .then(function (res) {
        if (res.data.status === 'ng') {
          return callback(new Error(res.data.errors.general));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  /*
  Change shipping method for the shipment of the shipmentId.
  @param {Object} params
  @param {String} params.shipmentId - cart.shipments.id, not Shipments._id
  @param {String} params.wishlistId
  @param {String} params.value - Shipping method
  */
  changeShippingMethod(params, callback) {
    if (!params) {
      params = {};
    }
    axios
      .post('/cart/shipping_method', {
        wishlist_id: params.wishlistId,
        shipment_id: params.shipmentId,
        value: params.value
      })
      .then(function (res) {
        if (res.data.status === 'ok') {
          return callback(null, res.data);
        } else {
          if (res.data.errors && res.data.errors.general === 'no target cart') {
            // ログイン状態が変更されていてカートの取得に失敗した場合、ページをリロードする
            // @SEE: #35842
            window.location.reload();
            return;
          }
          return callback(res.data.errors);
        }
      })
      .catch((err) => callback(err));
  },

  /*
  Fetch the values of the current cart.
  @param {Object} params
  @param {String} params.wishlistId
  @param {Boolean} params.fullValidation
  */
  check(params, callback) {
    if (!params) {
      params = {};
    }
    axios
      .get('/cart/check', {
        params: {
          wishlist_id: params.wishlistId,
          full_validation: params.fullValidation
        }
      })
      .then(function (res) {
        if (res.data.status !== 'ok') {
          return callback(new Error(res.data.errors.general));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  /*
  new API Fetch the values of the current cart.
  */
  cart(params, callback) {
    if (!params) {
      params = {};
    }
    axios
      .get('/api/cart', {
        params: {
          wishlist_id: params.wishlist_id
        }
      })
      .then(function (res) {
        if (res.data.status !== 'ok') {
          return callback(new Error(res.data.errors.general));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  qty(params, callback) {
    const { id, qty, wishlist_id, shipment_id, variation_id } = params;
    axios
      .post('/cart/qty', {
        id,
        qty,
        wishlist_id,
        shipment_id,
        variation_id
      })
      .then(function (res) {
        if (res.data.status !== 'ok') {
          return callback(new Error(res.data.errors.general));
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  /*
  Change shipping address for cart.
  @param {Object} params
  @param {String} params.wishlistId
  */
  changeCartShipping(params, callback) {
    if (!params) {
      params = {};
    }
    axios
      .post('/cart/change_cart_shipping', {
        wishlist_id: params.wishlistId
      })
      .then(function (res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  /*
  update Gift Wrapping
  @param {Object} params
  @param {String} params.cartId
  @param {String} params.shipmentId
  @param {String} params.giftWrapping
  @param {String} params.giftMessage
  @param {String} params.wishlistId
  */
  updateGiftWrapping(params, callback) {
    if (!params) {
      callback(new Error('Required value is not met'));
    }

    axios
      .post('/cart/update_gift_wrapping', {
        id: params.cartId,
        shipment_id: params.shipmentId,
        gift_wrapping: params.giftWrapping,
        gift_message: params.giftMessage,
        wishlist_id: params.wishlistId
      })
      .then(function (res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  /*
  Update point for cart.
  */
  updatePoint(params, callback) {
    const { wishlist_id, point } = params;
    axios
      .post('/cart/update_point', {
        wishlist_id,
        point
      })
      .then(function (res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  divideSkuFromShipment(params, callback) {
    axios
      .post('/cart/divide_sku_from_shipment', {
        id: params.cartId,
        shipment_id: params.shipmentId,
        sku_id: params.skuId
      })
      .then(function (res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  combineSkuToShipment(params, callback) {
    axios
      .post('/cart/combine_sku_to_shipment', {
        id: params.cartId,
        shipment_id: params.shipmentId,
        sku_id: params.skuId
      })
      .then(function (res) {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },

  /*
  Save for later
  */
  getSavedForLater(callback) {
    axios
      .get('/saved_for_later')
      .then((res) => {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },
  addToSavedForLater(params, callback) {
    axios
      .post('/saved_for_later/add', {
        product: params.product,
        sku: params.sku
      })
      .then((res) => {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  },
  deleteFromSavedForLater(params, callback) {
    axios
      .post('/saved_for_later/delete', {
        id: params.id
      })
      .then((res) => {
        if (res.data.status !== 'ok') {
          return callback(res.data.errors);
        }
        return callback(null, res.data);
      })
      .catch((err) => callback(err));
  }
};
